import type { ChartConfig } from './types';

/**
 * Default chart configuration.
 * Central source of truth for all chart behavior parameters.
 */
export const DEFAULT_CHART_CONFIG: ChartConfig = {
    viewportMs: 10000,
    rightMargin: 200,

    physics: {
        tension: 20.0,
        friction: 6.0,
        // Synthetic motion between sparse live ticks (the feed only pushes
        // on-change, ~1/s at most). Values below are now fractions of the
        // asset's visible spread (see calculatePhysicsStep visibleSpread),
        // so they're asset-agnostic. Tune to taste: higher = livelier.
        enableArtificialNoise: true,
        noiseStrength: 2.5,
        organicDriftScale: 0.4,
        adaptiveTension: {
            threshold: 1.5,
            exponent: 1.5,
            multiplier: 0.8,
            maxMultiplier: 15.0,
        },
    },

    scaling: {
        lerpFactor: 0.01, // Slower camera follow for smoother Y-axis movement
        padding: 1.3,
        minSpread: 20,
    },

    theme: {
        default: '#C8F224',
        bullish: '#C8F224',
        bearish: '#FF5C6E',
        profit: '#C8F224',
        grid: '#15170F',
        axisText: '#767B68',
        cursorText: '#ECEEE4',
    },

    layout: {
        axisTickCount: 6,
        axisFontSize: 10,
        cursorLabelOffsetX: 30,
    },

    trendDetection: {
        lookbackMs: 800,
        bullishThreshold: 0.4,
        bearishThreshold: -0.4,
    },
};
